import { MouseEvent, PropsWithChildren } from 'react'

import { combineClassnames } from 'app/common/presentation'
import { CloseIcon } from 'app/common/presentation/icons'

import styles from './CodeTag.module.scss'

export type CodeTagColor = 'grey' | 'purple'

interface CodeTagProps extends PropsWithChildren {
  className?: string
  color?: CodeTagColor
  onRemove?: () => void
  removeLabel?: string
}

const CodeTag = ({
  children,
  className,
  color = 'purple',
  onRemove,
  removeLabel = 'Remove',
}: CodeTagProps) => {
  const handleRemove = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    onRemove?.()
  }

  return (
    <span className={combineClassnames(styles.codeTag, className)} data-color={color}>
      <span>{children}</span>
      {onRemove && (
        <button aria-label={removeLabel} onClick={handleRemove} type="button">
          <CloseIcon />
        </button>
      )}
    </span>
  )
}

export default CodeTag
